





import { defineComponent } from '@vue/composition-api';

import PanelWithQuizEditor from '@/components/Live/PanelWithQuizEditor.vue';

const New = defineComponent({
  components: {
    PanelWithQuizEditor,
  },
  // setup() {},
});

export default New;
